import { memo } from 'react';

import { useTranslations } from 'next-intl';

import CloseIcon from '@/assets/icons/close-x.svg';
import { DialogClose } from '@/components/ui/dialog';
import { DrawerClose } from '@/components/ui/drawer';
import { cn } from '@/lib/utils/cn';
import { T_CloseButtonProps } from '@/ts/types/T_Overlay';
// Close Button Component
export const CloseButton = memo(
  ({ className, variant = 'drawer' }: T_CloseButtonProps) => {
    const CloseComponent = variant === 'drawer' ? DrawerClose : DialogClose;
    const t = useTranslations('accessibility');

    return (
      <CloseComponent
        aria-label={t('close')}
        className={cn(
          'absolute cursor-pointer right-3 top-3 grid h-8 w-8 place-items-center rounded-full hover:bg-white/10 focus-visible:outline-none',
          className
        )}
      >
        <CloseIcon color="var(--foreground-color)" />
      </CloseComponent>
    );
  }
);

CloseButton.displayName = 'CloseButton';
